import React, { useContext } from 'react'

import AddShopMenu from 'commonComponents/addShopMenu/AddShopMenu'
import { ThemeContext } from 'index'

const ShopAddShopMenu = (props) => {
	const theme = useContext(ThemeContext)
	// Router props are forwarded so the page can navigate without reaching
	// for window.location.
	return <AddShopMenu {...props} theme={theme} type="shopAdmin" />
}

export default ShopAddShopMenu
